export class Debouncer {
    private timeout: null | NodeJS.Timeout;
    protected delay: number;
    protected callback: null | (() => void);

    constructor(delay?: number) {
        this.delay = delay ?? 300;
        this.timeout = null;
        this.callback = null;
    }

    public run(callback: () => void, params?: { immediate?: boolean, delay?: number }) {
        const delay = params?.delay ?? this.delay;
        const immediate = params?.immediate ?? false;

        this.clear();

        this.callback = callback;

        if (immediate) {
            this.runCallback();
        } else {
            this.timeout = setTimeout(() => {
                this.runCallback();
                this.timeout = null;
            }, delay);
        }
    }

    public release() {
        this.clear();
    }

    public finalize() {
        this.runCallback();
    }

    public clear() {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    }

    protected runCallback() {
        this.clear();

        if (this.callback) {
            this.callback();

            this.callback = null;
        }
    }
}